import {
  createStyles,
  Box,
  Drawer,
  Text,
  Tabs,
  Accordion,
  Grid,
  TextInput,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import InvoiceHistory from "./InvoiceHistory";

const useStyles = createStyles((theme) => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#F5F5F5",
      borderRadius: "20px",
    },
  },
  tabContainer: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    border: "1px solid #E5E5E5",
    padding: "20px",
    width: "100%",
    height: "100%",
    marginTop: "10px",
  },
  tab_list: {
    width: "fit-content !important",
    "& .mantine-Tabs-tabsList": {},
  },
  panel: {
    padding: "10px",
    backgroundColor: "#FAFAFA",
    borderRadius: "8px",
  },
}));

const ViewConsumerDrawer = ({
  viewcustomer,
  setViewcustomer,
  customer,
  setIsPreview,
}) => {
  const { classes } = useStyles();

  const handleClose = () => {
    setViewcustomer(false);
    setIsPreview(false);
  };

  const billingInformation = [
    {
      title: "Billing Information",
      value: "Billing Information",
      content: (
        <Box>
          <Text ff={"Inter"} fz={15} fw={600} color="#000">
            Billing Address
          </Text>
          <Text ff={"Inter"} fz={14} fw={400} color="#737373">
            {customer?.address} {customer?.city} {customer?.state}{" "}
            {customer?.zipcode}{" "}
          </Text>
        </Box>
      ),
    },
  ];

  const items = billingInformation?.map((item) => (
    <Accordion.Item key={item.value} value={item.value}>
      <Accordion.Control>{item.value}</Accordion.Control>
      <Accordion.Panel className={classes.panel}>
        {item.content}
      </Accordion.Panel>
    </Accordion.Item>
  ));

  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Drawer
      size={850}
      shadow="md"
      offset={10}
      radius={"lg"}
      zIndex={1000}
      position="right"
      onClose={handleClose}
      opened={viewcustomer}
      overlayProps={{ blur: 3 }}
      className={classes.drawer}
      title={
        <Text tt={"capitalize"} fw={600} fz={20} ff={"Inter"}>
          {customer?.name}
        </Text>
      }
    >
      <Box className={classes.drawerViewCustomer}>
        <Box className={classes.tabContainer}>
          <Tabs defaultValue="overview" tabPadding="md" color="gray">
            <Tabs.List className={classes.tab_list}>
              <Tabs.Tab value="overview">Overview</Tabs.Tab>
              <Tabs.Tab value="invoice-history">Invoice History</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="overview">
              {" "}
              <Accordion defaultValue="Apples">{items}</Accordion>
              <Grid mt={10}>
                <Grid.Col span={isMobile ? 12 : 6}>
                  <TextInput
                    label="Email Address"
                    placeholder="Enter Email Address"
                    radius="md"
                    value={customer?.email}
                    disabled
                  />
                </Grid.Col>
                <Grid.Col span={isMobile ? 12 : 6}>
                  <TextInput
                    label="Phone Number"
                    placeholder="Enter Phone Number"
                    radius="md"
                    value={customer?.phone}
                    disabled
                  />
                </Grid.Col>
              </Grid>
            </Tabs.Panel>

            <Tabs.Panel value="invoice-history">
              <InvoiceHistory customer={customer} />
            </Tabs.Panel>
          </Tabs>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ViewConsumerDrawer;
